<template>
    <div id="all">
        <div id="all_div">
            <p class="all_p0">UPDATE</p>
            <p class="all_p1">网站全面升级中...</p>
            <p class="all_p2">国庆之后，敬请期待。</p>
        </div>
    </div>
</template>
<script>
export default {
    name:'cantuse',
    data(){
        return{

        }
    },
    methods:{

    },
    mounted:function(){

    }
}
</script>
<style scoped>
#all{
    width: 100%;
    height: 90%;
    background: #262631;
    text-align: center;
    padding-top: 20%;
}
.all_p0{
    font-size: .76rem;
    font-weight: bold;
    color: #fff;
}
.all_p1{
    font-size: .28rem;
    font-weight: bold;
    color: #fff;
}
.all_p2{
    font-size: .16rem;
    font-weight: bold;
    color: #fff;
    line-height: .46rem;
}
</style>


// WEBPACK FOOTER //
// src/view/canNotUse.vue